<template>
  <div class="aiVideo">
    <div class="left">
      <ul>
        <li v-for="(device, index) in videoList" :key="index">
          <div @click="setDeviceToBind(device.number,device.channel)">{{device.title}}({{device.name}})</div>
        </li>
      </ul>
    </div>
    <div class="center" :class="`videos-${videos.length}`">
      <video-box
        ref="child"
        class="video-preview"
        :class="{ 'is-binding': deviceToBind }"
        v-for="(video, index) in videos"
        :key="index"
        :activated="activatedVideo === video"
        :video="video"
        :rnd="video.rnd"
        @click.native="deviceToBind ? bindDevices(video) : activeVideo(video)">
      </video-box>
    </div>
    <div class="ai_info">
      <ul class="ai_title">
        <li class="l1">{{$t('ai.warn_time')}}</li>
        <li class="l2">{{$t('ai.warn_camera')}}</li>
        <li class="l3">{{$t('ai.camera_number')}}</li>
        <li class="l4">{{$t('ai.camera_remark')}}</li>
        <li class="l6" @click="openWarnList"><span>{{$t('ai.warn_log')}}</span></li>
        <li class="l5">{{$t('ai.warn_view')}}</li>
      </ul>
      <div class="ai_con">
        <ul v-for="(item, index) in baojingData" :key="index" @click="view_warn(item)">
          <li class="l1">{{item.target_begin_time}}</li>
          <li class="l2">{{item.title}}</li>
          <li class="l3">{{item.number}}</li>
          <li class="l4">{{item.target_name}}</li>
        </ul>
        <div class="pic_view"><img :src="nowBaojingPic" /></div>
      </div>
    </div>
    <div class="right">
      <div class="count-control">
        <div class="count-control-1" @click="createVideos(1)">
          <div></div>
        </div>
        <div class="count-control-4" @click="createVideos(4)">
          <div v-for="i in [1,2,3,4]" :key="i"></div>
        </div>
        <div class="count-control-9" @click="createVideos(9)">
          <div v-for="i in [1,2,3,4,5,6,7,8,9]" :key="i"></div>
        </div>
      </div>
      <video-control :video="activatedVideo"></video-control>
    </div>
    <div class="warning_one" v-if="warnOneVibity">
      <ai-one 
        :dataOne="warnData" 
        :accessToken="activatedVideo.access_token" 
        ref="warnOne"
        @closeMethod="closeWarnOne"
        >
      </ai-one>
    </div>
    <!--设备配置-->
    <el-dialog
      :title="$t('ai.warn_log')"
      :visible.sync="warnListVibity"
      v-if="warnListVibity"
    >
      <ai-warn-list 
        ref="warnList"
        @closeMethod="closeWarnList"
        >
      </ai-warn-list>
    </el-dialog>
  </div>
</template>
<script>
import cameraApi from "@/api/device/camera"
import aiListApi from "@/api/aivideo/aiList"
import videoBox from '@/components/video/VideoBox.vue'
import videoControl from '@/components/video/VideoControl.vue'
import aiOne from '@/components/ai/aiOne.vue'
import aiWarnList from '@/components/ai/aiWarnList.vue'
export default {
  components: {
    videoBox,
    videoControl,
    aiOne,
    aiWarnList
  },
  data () {
    return {
      videoList: [],
      videos: [],
      deviceToBind: null,
      activatedVideo: {},
      controlSpeed: 50,
      baojingData: [
        {
          alarm_id: 0,
          created_at: 0,
          number: "0",
          picture: "",
          ste: 0,
          remark: '',
          target_begin_time: "",
          target_name: "",
          title: "",
          type: 0
        }
      ],
      nowBaojingPic: '',
      warnOneVibity: false,
      warnListVibity: false,
      warnData: {
        alarm_id: 0,
        created_at: 0,
        number: "",
        channel: 1, //通道号
        picture: "",
        ste: 0,
        remark: '',
        target_begin_time: "",
        target_name: "",
        title: "",
        type: 0
      },
      timer: null,
      timerNew: null
    }
  },
  methods: {
    baojingList() {
      aiListApi.getAiListApi({
        page: 1,
        pageSize: 6
      }).then((res) => {
        if (res.data.code === 1000) {
          if(res.data.data.list.length){
            this.baojingData = res.data.data.list;
            this.nowBaojingPic = res.data.data.list[0].picture
          }
        }
      });
    },
    aiNewOne() {
      aiListApi.aiNewListApi().then((res) => {
        if (res.data.code === 1000) {
          let resData =res.data.data
          if(!this.warnOneVibity){
            if(resData.length>0){
              if(resData[0].type==0){
                this.warnOneVibity = true
                this.warnData = res.data.data[0];
              }else{
                this.warnOneVibity = false
                this.warnData = {
                  alarm_id: 0,
                  created_at: 0,
                  number: "0",
                  channel: 1, //通道号
                  remark: '',
                  picture: "",
                  ste: 0,
                  target_begin_time: "",
                  target_name: "",
                  title: "",
                  type: 0
                }
              }
            }
          }
        }
      });
    },
    closeWarnOne() {
      this.warnOneVibity = false
      this.warnData = {
        alarm_id: 0,
        created_at: 0,
        number: "0",
        channel: 1, //通道号
        picture: "",
        ste: 0,
        remark: '',
        target_begin_time: "",
        target_name: "",
        title: "",
        type: 0
      }
    },
    openWarnList() {
      this.warnListVibity = true
    },
    closeWarnList() {
      this.warnListVibity = false
    },
    view_warn(e) {
      // console.log('view_warn',e.alarm_id)
      this.warnOneVibity = false
      this.nowBaojingPic = e.picture
      aiListApi.getAiInfo(e.alarm_id).then((res) => {
        if (res.data.code === 1000) {
          let resData =res.data.data
          this.warnData = resData
          this.warnOneVibity = true
        }
      });
    },
    getLeftList() {
      cameraApi.cameraList({
        page: 1,
        pageSize: 200,
        type:1
      }).then((res) => {
        if (res.data.code === 1000) {
          this.videoList = res.data.data.list;
          if(res.data.data.list.length) {
            this.getFirstVideo(res.data.data.list[0].number, res.data.data.list[0].channel)
          }
        }
      });
    },
    getFirstVideo(number, channel){
      cameraApi.cameraInfo({
        number: number,
        channel: channel
      }).then((res) => {
        if (res.data.code === 1000) {
          const {camera_type, channel, access_token} = res.data.data
          this.activatedVideo = {
            index: 0,
            number: number,
            camera_type: camera_type,
            channel: channel,
            access_token: access_token,
            rnd: Math.random()
          }
          this.createVideos(4)
        }
      });
    },
    createVideos (count) {
      if ([1, 4, 9].indexOf(count) < 0) {
        return
      }
      if (this.activatedVideo && count <= this.activatedVideo.index) {
        this.activatedVideo = {}
      }
      if (count > this.videos.length) {
        for (let i = this.videos.length; i < count; i++) {
          this.videos.push({
            index: i,
            number: '',
            camera_type: 1,
            channel: 1,
            access_token: '',
            rnd: Math.random()
          })
        }
      } else if (count < this.videos.length) {
        const videos = []
        for (let i = 0; i < count; i++) {
          videos.push(this.videos[i])
        }
        this.videos = videos
      }
    },
    setDeviceToBind (number,channel) {
      if (this.deviceToBind && this.deviceToBind.number === number) {
        this.deviceToBind = null
      } else {
        cameraApi.cameraInfo({
          number: number,
          channel: channel
        }).then((res) => {
          if (res.data.code === 1000) {
            const {camera_type, channel, access_token} = res.data.data
            this.deviceToBind = {
              number: number,
              camera_type: camera_type,
              channel: channel,
              access_token: access_token,
            }
            this.activatedVideo = this.deviceToBind
          }
        });
      }
    },
    bindDevices (video) {
      video.rnd = Math.random()
      video.number = this.deviceToBind.number //设备序列号
      video.camera_type = this.deviceToBind.camera_type //设备序列号
      video.channel = this.deviceToBind.channel //通道号
      video.access_token = this.deviceToBind.access_token //通道号
      this.deviceToBind = null
    },
    activeVideo (video) {
      if (this.activatedVideo === video) {
        this.activatedVideo = null
      } else {
        this.activatedVideo = video
      }
    }
  },
  created () {
    this.getLeftList()
    // 下面为制作定时器（首页模块数据）
    this.baojingList()
    if (this.timer) {
      clearInterval(this.timer)
    } else {
      this.timer = setInterval(() => {
        setTimeout(this.baojingList(), 0)
      }, 6 * 1000)
    }
    this.aiNewOne()
    if (this.timerNew) {
      clearInterval(this.timerNew)
    } else {
      this.timerNew = setInterval(() => {
        setTimeout(this.aiNewOne(), 0)
      }, 6 * 1000)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null

    clearInterval(this.timerNew)
    this.timerNew = null
  }
}
</script>
  
<style lang='less' scoped>
.aiVideo{
  width: 100%;
  height: 100%;
  position: relative;
  .num {
    height: 100%;
    width: 100%;
  }
  .left {
    position: fixed;
    top: 60px;
    left: 0px;
    bottom: 0px;
    width: 180px;
    background: #333;
    color:#fff;
  }
  .left .el-select {
    display: block;
    margin: 15px 0;
    padding: 0 15px;
    box-sizing: border-box;
  }
  .left .el-select + svg {
    display: none;
  }
  .left ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .left ul div {
    line-height:1.4;
    padding: 10px 20px;
    box-sizing: border-box;
    font-size: 14px;
    cursor: pointer;
  }
  .left ul div:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  .left > ul {
    font-size: 16px;
    margin: 15px 0;
  }
  .center {
    position: fixed;
    top: 60px;
    left: 180px;
    right: 240px;
    bottom: 220px;
    box-sizing: border-box;
  }
  .right {
    position: fixed;
    top: 60px;
    bottom: 0px;
    right: 0px;
    width: 240px;
    background: #333;
    color: #fff;
  }
  .video-preview-control{
    margin: 0 auto;
  }

  .video-preview-control-main {
      position: relative;
      padding-top: 100%;
      margin-top: 10px;
  }
  .circle {
      position: absolute;
      top: 15px;
      left: 15px;
      right: 15px;
      bottom: 15px;
      border-radius: 50%;
      border: 40px solid #3f475a;
      box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
      background: #1b1b1b;
  }
  .arrow {
      position: absolute;
      cursor: pointer;
      user-select: none;
  }
  .arrow:before {
      content: '';
      display: inline-block;
      position: absolute;
      border: 10px solid #ccdaeb;
      z-index: 1;
  }
  .arrow:hover:before {
      border: 10px solid #fff;
  }
  .arrow:active:before {
      border: 10px solid #666;
  }
  .arrow:after {
      content: '';
      display: inline-block;
      position: absolute;
      border: 10px solid transparent;
      z-index: 0;
  }
  .arrow-up {
      top: -40px;
      left: 0;
      width: 70px;
      height: 40px;
  }
  .arrow-up:before {
      top: 5px;
      left: 25px;
      border-top-color: transparent !important;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
  }
  .arrow-up:after {
      top: 7px;
      left: 27px;
      border-bottom-color: rgba(0, 0, 0, 0.3);
  }
  .arrow-left {
      top: 0;
      left: -40px;
      width: 40px;
      height: 70px;
  }
  .arrow-left:before {
      top: 25px;
      left: 5px;
      border-top-color: transparent !important;
      border-left-color: transparent !important;
      border-bottom-color: transparent !important;
  }
  .arrow-left:after {
      top: 27px;
      left: 7px;
      border-right-color: rgba(0, 0, 0, 0.3);
  }
  .arrow-right {
      top: 0;
      left: 70px;
      width: 40px;
      height: 70px;
  }
  .arrow-right:before {
      top: 25px;
      left: 15px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
  }
  .arrow-right:after {
      top: 27px;
      left: 17px;
      border-left-color: rgba(0, 0, 0, 0.3);
  }
  .arrow-down {
      top: 70px;
      left: 0;
      width: 72px;
      height: 40px;
  }
  .arrow-down:before {
      top: 15px;
      left: 25px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
  }
  .arrow-down:after {
      top: 17px;
      left: 27px;
      border-top-color: rgba(0, 0, 0, 0.3);
  }
  .camera {
      position: absolute;
      background: #cfdff1;
      color: #1b1b1b;
      width: 48px;
      height: 24px;
      line-height: 20px;
      text-align: center;
      left: 11px;
      box-sizing: border-box;
      font-size: 16px;
      cursor: pointer;
      user-select: none;
  }
  .camera-up {
      top: 11px;
      border-top-left-radius: 48px;
      border-top-right-radius: 48px;
      border-bottom: 1px solid #1b1b1b;
  }
  .camera-down {
      bottom: 11px;
      border-bottom-left-radius: 48px;
      border-bottom-right-radius: 48px;
      border-top: 1px solid #1b1b1b;
  }
  .slider {
      overflow: hidden;
  }
  .slider > * {
      float: left;
  }
  .slider > span {
      display: inline-block;
      width: 30px;
      text-align: center;
      height: 36px;
      line-height: 36px;
      vertical-align: top;
  }
  .slider .speed {
      width: 120px;
  }
  .right .count-control {
    border-bottom: 1px solid #696969;
    overflow: hidden;
    text-align: center;
    height: 80px;
  }
  .right .count-control > div {
    display: inline-block;
    width: 36px;
    height: 36px;
    margin: 20px 5px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #696969;
    background: #23252a;
    box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
    cursor: pointer;
  }
  .right .count-control > div > div {
    float: left;
    border: 1px solid #696969;
    margin: -1px;
  }
  .right .count-control-1 > div {
    width: 36px;
    height: 36px;
  }
  .right .count-control-4 > div {
    width: 18px;
    height: 18px;
  }
  .right .count-control-9 > div {
    width: 12px;
    height: 12px;
  }
  .videos-1 .video-container {
    width: 100%;
    height: 100%;
  }
  .videos-4 .video-container {
    width: 50%;
    height: 50%;
  }
  .videos-9 .video-container {
    width: 33.333333%;
    height: 33.333333%;
  }
  .video-preview.is-binding {
    cursor: pointer;
  }
  .video-preview.is-binding:before {
    content: '在这里显示';
    display: block;
    position: absolute;
    font-size: 24px;
    color: #fff;
    background: #000;
    width: 100%;
    height: 100%;
    text-align: center;
    box-sizing: border-box;
    padding-top: 2em;
    opacity: 0.5;
    z-index: 2;
  }
  .video-preview.is-binding:hover:before {
    opacity: 0.7;
  }
  .right .count-control {
    border-bottom: 1px solid #696969;
    overflow: hidden;
    text-align: center;
    height: 80px;
  }
  .right .count-control > div {
    display: inline-block;
    width: 36px;
    height: 36px;
    margin: 20px 5px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #696969;
    background: #23252a;
    box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
    cursor: pointer;
  }
  .right .count-control > div > div {
    float: left;
    border: 1px solid #696969;
    margin: -1px;
  }
  .right .count-control-1 > div {
    width: 36px;
    height: 36px;
  }
  .right .count-control-4 > div {
    width: 18px;
    height: 18px;
  }
  .right .count-control-9 > div {
    width: 12px;
    height: 12px;
  }
  .autocomplete-wrapper {
    position: relative;
  }
  .autocomplete-wrapper .el-input input {
    border-radius: 18px;
    padding-right: 35px;
  }
  .autocomplete-search {
    position: absolute;
    top: 10px;
    right: 30px;
    color: #333;
  }
}

.ai_info{
  background: #32373e;
  position: fixed;
  height:220px;
  left: 180px;
  right: 240px;
  bottom: 0;
  ul{
    list-style: none;
    margin:0;
    padding:0;
    li{
      width:180px;
      float: left;
      color:#fff;
      line-height: 30px;
      font-size: 14px;
      text-align: center;
      font-weight: bold;
    }
  }
  .ai_title{
    background: #333;
    height:30px;
    .l5{
      float: right;
      width:132px;
      text-align: left;
    }
    .l6{
      float: right;
      width:100px;
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height:30px;
      span{
        display: inline-block;
        line-height: 20px;
        font-size: 12px;
        text-align: center;
        padding:0 10px;
        background: #409eff;
        color:#fff;
        font-weight: normal;
        cursor: pointer;
      }
    }
  }
  .ai_con{
    position:relative;
    height:190px;
    padding-top: 5px;
    ul{
      width:100%;
      height: 30px;
      li{
        color:#fff;
        font-size: 12px;
        font-weight: normal;
      }
      &:hover{
        background: #409eff;
        cursor: pointer;
      }
    }
    
  }
  .pic_view{
    position: absolute;
    right:0px;
    top:0;
    img{
      height: 190px;
      width: auto;
    }
  }
}

.warning_one {
  width:1100px;
  height:435px;
  position: fixed;
  top:150px;
  left:50%;
  margin-left:-550px;
  box-sizing: border-box;
  z-index: 9999;
}
.warn_list{
  width:74%;
  min-width: 1200px;
  height:80%;
  position: fixed;
  top:10%;
  left:13%;
  box-sizing: border-box;
  z-index: 99999;
}
</style>